import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#2A2A2A] via-[#1F1F1F] to-[#2A2A2A] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/37c346696e9c186876a9132ed1f3a01c.png" 
                alt="Kudima" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white text-base font-medium leading-relaxed mb-4">
              Excelência em Soluções Corporativas
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/maiskudima"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#CB9832] transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/maiskudima?igsh=MXR5dWNubmtyeDUxag=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#CB9832] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Empresa */}
          <div>
            <h3 className="font-bold text-sm mb-4">EMPRESA</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/quem-somos" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  SOBRE NÓS
                </Link>
              </li>
              <li>
                <Link to="/quem-somos#equipe" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  A EQUIPA
                </Link>
              </li>
              <li>
                <Link to="/quem-somos#missao" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  MISSÃO
                </Link>
              </li>
              <li>
                <Link to="/quem-somos#valores" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  VALORES
                </Link>
              </li>
            </ul>
          </div>

          {/* SERVIÇOS */}
          <div>
            <h3 className="font-bold text-sm mb-4">SERVIÇOS</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/servicos" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  CONSULTORIA
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  MARKETING & COMUNICAÇÃO
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  FORMAÇÕES
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  PROJECTOS
                </Link>
              </li>
              <li>
                <Link to="/eventos" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  EVENTOS & INICIATIVAS
                </Link>
              </li>
            </ul>
          </div>

          {/* SUPORTE */}
          <div>
            <h3 className="font-bold text-sm mb-4">SUPORTE</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contato" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  CONTACTO
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  RENÚNCIA DE RESPONSABILIDADE
                </Link>
              </li>
              <li>
                <Link to="/politica-cookies" className="text-gray-400 hover:text-[#CB9832] transition-colors text-sm cursor-pointer">
                  POLÍTICA DE PRIVACIDADE
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © {currentYear} +KUDIMA. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
